import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';
import type { Id } from '@e-socna/data-layer';

export const ResolvableMissionTypeForm_ResolvableMissionType_Fragment = graphql(
  `
    fragment ResolvableMissionTypeForm_ResolvableMissionType_Fragment on ResolvableMissionType {
      _id
      codingConfig {
        kind
        strategyId
        ... on CodingConfigManual {
          code
        }
        ...CodeCmp_CodingConfig_Fragment
      }

      # Info
      code
      label
      categoryParentId
      categoryLeaf
      title
      content

      # Templates
      reportTemplateIds
      quotationTemplateId

      # Quotation Header
      quotationHeader {
        ...QuotationHeaderForm_QuotationHeader_Fragment
      }

      # Service Usages
      serviceUsagesGroups {
        ...ResolvableServiceUsagesGroupForm_ResolvableServiceUsagesGroup_Fragment
      }

      # Files
      allowedFileCategoryIds

      # Toolkits
      enabledToolkitIds

      # Other
      statusId
    }
  `,
);

export type ResolvableMissionTypeForm_ResolvableMissionType = ResultOf<
  typeof ResolvableMissionTypeForm_ResolvableMissionType_Fragment
>;

export interface RequiredResolvableMissionTypeFormContext {
  readonly typeId: Id;
}

export interface OptionalResolvableMissionTypeFormContext {
  readonly typeId?: Id;
}
